<template>
  <div>
    <meta name="apple-itunes-app" :content="appleItunesAppId" />
    <div
      v-if="appBannerVisible"
      class="d-flex align-center pt-1 pb-2 bg-white position-relative l-spacing-half"
    >
      <div class="d-flex align-center pl-3 pr-2">
        <img
          width="40"
          height="40"
          id="app-icon"
          src="@/assets/images/icons/app_icon.png"
          alt="vicampo-app-icon"
        />
      </div>
      <a
        class="pr-5 d-flex flex-column"
        :href="appLink"
        rel="noreferrer"
        target="_blank"
      >
        <div class="pb-1">
          <span class="c-gray font-size-m bold">VICAMPO APP</span>
          <Stars class="mx-1 font-size-m" />
        </div>
        <VBtnSecondary class="font-size-xs">{{
          translate('fe_app_pdp_download_now')
        }}</VBtnSecondary>
      </a>
      <button
        type="button"
        class="close"
        @click="close"
        aria-label="close-banner"
      >
        <SvgWrapper use="icon_svg_close" dimensions="20" />
      </button>
    </div>
  </div>
</template>

<script>
import SiteConfig from '@/services/SiteConfig'
import { defineAsyncComponent } from 'vue'

const Stars = defineAsyncComponent(
  () => import('@/components/basic/atoms/Stars.vue')
)
const SvgWrapper = defineAsyncComponent(
  () => import('@/components/basic/atoms/SvgWrapper.vue')
)
const APP_LINK =
  'https://play.google.com/store/apps/details?id=de.vicampo.android.customersapp'
const BANNER_HIDDEN = 'banner_hidden'
const DEVICES = {
  IOS: ['iphone', 'ipad'],
  ANDROID: 'android'
}
// not ios & page has banner & android device & not hid by the customer
const getIInitialValue = (agent) => {
  return (
    !DEVICES.IOS.some((device) => agent.includes(device)) &&
    SiteConfig.appBanner &&
    agent.includes(DEVICES.ANDROID) &&
    !JSON.parse(localStorage.getItem(BANNER_HIDDEN))
  )
}

export default {
  components: { Stars, SvgWrapper },
  props: {
    agent: {
      type: String,
      // No `navigator` at module scope: this file is evaluated during SSR too,
      // where it resolves to Node's own user agent ("node.js/22") rather than
      // the visitor's. mounted() reads the real one; the prop stays an
      // explicit override for tests.
      default: undefined
    }
  },
  data() {
    return {
      appBannerVisible: false
    }
  },
  computed: {
    appLink() {
      return APP_LINK
    },
    appleItunesAppId() {
      return SiteConfig.appleItunesAppId
    }
  },
  methods: {
    close() {
      localStorage.setItem(BANNER_HIDDEN, 'true')
      this.appBannerVisible = false
    }
  },
  // Client-only on purpose. Visibility depends on the visitor's device and on
  // a localStorage dismissal, and the server render is anonymous, cached and
  // shared across visitors — so it must carry neither. Deciding after mount
  // keeps the hydration render identical to the server's (banner hidden) and
  // reveals the banner afterwards; deciding in created() made the first client
  // render disagree with the server markup on every Android visit
  // (VIP-12333).
  mounted() {
    this.appBannerVisible = getIInitialValue(
      this.agent ?? navigator.userAgent.toLowerCase()
    )
  }
}
</script>

<style lang="css" scoped>
.close {
  position: absolute;
  padding: 10px 10px 25px 0;
  right: 0;
}

.close > svg {
  stroke-width: 1px;
}

#app-icon {
  max-width: 40px;
  max-height: 40px;
  -webkit-box-shadow: rgba(0, 0, 0, 0.25) 0 1px 3px 0;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.25);
  border-radius: 0.5rem;
}

a > :first-child {
  word-break: break-all;
}

span.btn {
  min-height: 1.1rem;
  display: inline-flex;
  min-width: 135px;
  max-width: 132px;
  height: 1.1rem;
  padding: 0.6rem 0.3rem;
}
</style>
